import React, { Component } from 'react';
import CommunityInbox from './CommunityInbox';

class MainInboxContainerView extends Component {
    render() {
        return (
            <CommunityInbox otherPersonId={parseInt(this.props.match.params.id, 10)}
                uniqueName={this.props.match.params.unique_name}/>
        );
    }
}

export default MainInboxContainerView;
